var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-4",attrs:{"small":"","color":"primary","dark":_vm.selectedFiles.length > 0,"disabled":_vm.selectedFiles.length < 1},on:{"click":_vm.download}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-cloud-download")]),_vm._v(" Download Zip ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }